import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';
import moment from 'moment';

export default class CocktailBadge extends WritingBadge {
  public readonly id = BadgeId.cocktail;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    if (!stats.todaysPage) {
      return false;
    }

    const day = moment(stats.todaysPage.createdAt)
      .toDate()
      .getDay();
    const isWeekend = day === 6 || day === 0; // 6 = Saturday, 0 = Sunday
    return isWeekend;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/cocktail.ts